<template>
  <div class="sf-container"
       v-if="settings != null && settings.testMode">
    <v-alert class="sf-alert"
             dense
             text
             type="warning">
      <strong>{{ $t('testMode') }}</strong> {{ settings.guardMode }}
    </v-alert>
  </div>
</template>

<script>
  export default {
    computed: {
      settings() {
        return this.$store.getters.emailDesigner.settings
      }
    },
    name: 'EmailTestModeBanner'
  }
</script>

<i18n>
  {
    "de": {
      "testMode": "E-Mail-Testmodus aktiv:"
    },
    "en": {
      "testMode": "Email test mode active:"
    }
  }
</i18n>
